(() => {
  const HELP_TEXT_SELECTOR = 'span.po-field-helpText';
  const POPUPS = [
    {
      label: 'Size Guide & Tips',
      modalId: 'EasifySizeChartModal',
      aliases: ['Size Guide & Tips', 'Size Guide and Tips', 'Size chart', 'Size Chart'],
    },
    {
      label: 'Details',
      modalId: 'EasifyWhatIsThisModal',
      aliases: ['Details', 'What is this?', 'What is this'],
    },
  ];

  function normalizeLabel(value) {
    return (value || '')
      .replace(/[   ]/g, ' ')
      .replace(/[‘’]/g, "'")
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  const POPUP_BY_LABEL = new Map();
  POPUPS.forEach((popup) => {
    popup.aliases.forEach((alias) => {
      POPUP_BY_LABEL.set(normalizeLabel(alias), popup);
    });
  });

  function openHelpPopup(modalId, opener) {
    const modal = document.getElementById(modalId);
    if (modal && typeof modal.show === 'function') {
      modal.show(opener);
    }
  }

  function enhanceHelpText(root) {
    const scope = root instanceof Element ? root : document;
    if (!scope.querySelectorAll) return;

    scope.querySelectorAll(HELP_TEXT_SELECTOR).forEach((span) => {
      if (span.dataset.easifyHelpPopupEnhanced === 'true') return;

      const popup = POPUP_BY_LABEL.get(normalizeLabel(span.textContent));
      if (!popup || !document.getElementById(popup.modalId)) return;

      span.dataset.easifyHelpPopupEnhanced = 'true';

      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'link easify-help-popup__trigger';
      trigger.textContent = popup.label;
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        openHelpPopup(popup.modalId, trigger);
      });

      span.replaceWith(trigger);
    });
  }

  function observeProductInfo(productInfo) {
    if (!productInfo || productInfo.dataset.easifyHelpObserved === 'true') return;
    productInfo.dataset.easifyHelpObserved = 'true';

    enhanceHelpText(productInfo);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          enhanceHelpText(node);
        });
      });
    });

    observer.observe(productInfo, { childList: true, subtree: true });
  }

  function init() {
    const hasModal = POPUPS.some((entry) => document.getElementById(entry.modalId));
    if (!hasModal) return;

    document.querySelectorAll('product-info').forEach(observeProductInfo);
  }

  // Expose for dynamically loaded content (e.g. quick view popup) to re-initialize.
  window.EasifyHelpPopups = {
    enhance: enhanceHelpText,
    observe: observeProductInfo,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
